import { AuthStatus, useAuthContext } from "./AuthProvider";
import { ChatHistoryProvider } from "./ChatHistoryProvider";
import { SettingsContextProvider } from "./SettingsProvider";
import LoadingScreen from "./components/LoadingScreen";
import { LoginForm } from "./components/Login";
import Main from "./components/Main";
import NavBar from "./components/NavBar/NavBar";
import InfoBar from "./components/InfoBar/InfoBar";
import { AgentProvider } from "./AgentsContext"
import { PatientProfileProvider } from "./PatientProfileProvider";


function App() {
    const { authStatus } = useAuthContext();
    console.log(authStatus);
    document.documentElement.classList.add('dark');

    if (authStatus === AuthStatus.UNIDENTIFIED_USER) {
        return <LoginForm />;
    }
    if (authStatus === AuthStatus.PENDING) {
        return <LoadingScreen />;
    }
    if (authStatus === AuthStatus.NOT_AUTHENTICATED) {
        return <LoginForm />;
    }
    if (authStatus === AuthStatus.ERROR) {
        return <>Something went wrong!</>;
    }
    return (
        <SettingsContextProvider>
            <AgentProvider>
                    <PatientProfileProvider>
                <ChatHistoryProvider>
                        <div className=" w-full h-full relative flex">
                            <NavBar />
                            <Main />
                            <InfoBar />
                        </div>
                </ChatHistoryProvider>
                    </PatientProfileProvider>
            </AgentProvider>
        </SettingsContextProvider>
    );
}

export default App;
